import React, { useMemo } from "react";
import Chart from "react-apexcharts";

export default function RadialBarChartComponent({ data = 0, title = '' }) {
    // Ensure that data is either a valid number or default to 0
    const chartValue = useMemo(() => (typeof data === 'number' && !isNaN(data) ? data : 0), [data]);
    const formattedTitle = useMemo(() => title.toUpperCase(), [title]);

    const chartData = useMemo(() => ({
        series: [chartValue],
        options: {
            chart: {
                height: 350,
                type: 'radialBar',
                toolbar: { show: false },
            },
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 225,
                    hollow: {
                        margin: 0,
                        size: '70%',
                        background: 'transparent',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24,
                        },
                    },
                    track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0,
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35,
                        },
                    },
                    dataLabels: {
                        show: true,
                        name: {
                            offsetY: -10,
                            show: true,
                            color: '#888',
                            fontSize: '17px',
                        },
                        value: {
                            formatter: (val) => `${isNaN(val) ? 0 : parseInt(val, 10)}%`,
                            color: 'var(--textPrimary)',
                            fontSize: '36px',
                            show: true,
                        },
                    },
                },
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    gradientToColors: ['var(--barPrimary)','var(--barSecondary)' ],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100],
                },
            },
            stroke: {
                lineCap: 'round',
            },
            labels: [formattedTitle],
        },
    }), [chartValue, formattedTitle]);

    return (
        <div className="chartContainer w-full px-6">
            <Chart options={chartData.options} series={chartData.series} type="radialBar" height={250} />
        </div>
    );
}
